import { html as e, when as r } from "@microsoft/fast-element";
const t = e`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.9976 0.669621C14.2905 0.376728 14.7653 0.376728 15.0582 0.669621L16.8854 2.4968L16.8906 2.50192L16.8924 2.50381L21.3084 6.91977L21.3164 6.92766L21.3276 6.93894L23.255 8.86643C23.5479 9.15932 23.5479 9.6342 23.255 9.92709C22.9622 10.22 22.4873 10.22 22.1944 9.92709L20.7919 8.5246C18.6282 10.7472 17.1939 12.5326 16.1851 14.3531C15.1525 16.2166 14.545 18.1545 14.0889 20.7002L14.9831 21.5944C15.276 21.8873 15.276 22.3622 14.9831 22.6551C14.6902 22.948 14.2154 22.948 13.9225 22.6551L8.09979 16.8324L3.25123 21.681C2.95834 21.9739 2.48346 21.9739 2.19057 21.681C1.89768 21.3881 1.89768 20.9132 2.19057 20.6203L7.03913 15.7717L2.3415 11.0741C2.33533 11.0681 2.32925 11.0621 2.32327 11.0559L1.26964 10.0023C0.976749 9.70936 0.976749 9.23449 1.26964 8.94159C1.56254 8.6487 2.03741 8.6487 2.3303 8.94159L3.11814 9.72943C5.66372 9.27333 7.60167 8.66581 9.46507 7.63326C11.2857 6.62443 13.071 5.19015 15.2937 3.02638L13.9976 1.73028C13.7047 1.43739 13.7047 0.962514 13.9976 0.669621Z"
      fill="currentColor"
    />
  </svg>
`, n = e`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" fill="none">
    <path
      d="M0.799988 9.47192L13.4528 22.1248"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.5279 1.19995L21.7247 9.39676"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.2832 20.955C13.2277 15.3832 14.8263 12.4507 19.7877 7.45947"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.86314 10.5352C7.43488 9.59071 10.3674 7.99208 15.3586 3.03066"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.97092 15.9006L1.72092 21.1506"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`, l = e`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.5763 0.46967C11.8692 0.176777 12.344 0.176777 12.6369 0.46967L14.1525 1.98527L14.1641 1.99668L14.1723 2.00503L17.8435 5.67625L17.8518 5.68439L17.8632 5.69595L19.4676 7.30035C19.7605 7.59324 19.7605 8.06811 19.4676 8.36101C19.1747 8.6539 18.6998 8.6539 18.4069 8.36101L17.3279 7.28193C15.5778 9.08811 14.4163 10.5428 13.5969 12.0215C12.7538 13.5431 12.2526 15.127 11.8754 17.208L12.5743 17.907C12.8672 18.1999 12.8672 18.6748 12.5743 18.9677C12.2814 19.2606 11.8066 19.2606 11.5137 18.9677L6.74979 14.2038L2.79776 18.1558C2.50486 18.4487 2.02999 18.4487 1.7371 18.1558C1.4442 17.8629 1.4442 17.3881 1.7371 17.0952L5.68913 13.1431L0.969655 8.42364C0.676761 8.13075 0.676761 7.65587 0.969655 7.36298C1.26255 7.07009 1.73742 7.07009 2.03031 7.36298L2.64048 7.97315C4.72149 7.59594 6.30537 7.09474 7.82697 6.25159C9.3057 5.43219 10.7604 4.27073 12.5666 2.52064L11.5763 1.53033C11.2834 1.23744 11.2834 0.762563 11.5763 0.46967Z"
      fill="currentColor"
    />
  </svg>
`, C = e`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.26101 0.375687C9.49533 0.141373 9.87523 0.141373 10.1095 0.375687L11.322 1.58817L11.3313 1.5973L11.3378 1.60398L14.2748 4.54095L14.2815 4.54747L14.2906 4.55671L15.5741 5.84023C15.8084 6.07454 15.8084 6.45444 15.5741 6.68876C15.3398 6.92307 14.9599 6.92307 14.7256 6.68876L13.8623 5.8255C12.4622 7.27044 11.5331 8.4342 10.8775 9.61718C10.203 10.8345 9.80206 12.1016 9.50029 13.7664L10.0595 14.3256C10.2938 14.5599 10.2938 14.9398 10.0595 15.1741C9.82515 15.4084 9.44526 15.4084 9.21094 15.1741L5.39984 11.363L2.2382 14.5246C2.00389 14.7589 1.62399 14.7589 1.38968 14.5246C1.15536 14.2903 1.15536 13.9104 1.38968 13.6761L4.55131 10.5144L0.775724 6.73886C0.541409 6.50455 0.541409 6.12465 0.775724 5.89034C1.01004 5.65602 1.38994 5.65602 1.62425 5.89034L2.11239 6.37847C3.77719 6.0767 5.04429 5.67574 6.26158 5.00122C7.44456 4.34571 8.60832 3.41654 10.0533 2.01646L9.26101 1.22422C9.0267 0.989901 9.0267 0.610002 9.26101 0.375687Z"
      fill="currentColor"
    />
  </svg>
`, L = e`
  ${r((o) => o._type === "outline", n)}
  ${r((o) => o._type === "solid", t)}
  ${r((o) => o._type === "mini", l)}
  ${r((o) => o._type === "micro", C)}
`;
export {
  L as pinTemplate
};
